import { formatDate } from '@/dayjs'
import type { MarqueeExportRecord } from '@/sdk'
import { useTranslation } from '@/translations/i18n'

/**
 * Tab heading. Three copy states: pre-download with rows still pending,
 * pre-download all-resolved (the CSV is ready), and post-download (a CSV
 * exists and the job left is the Salesforce upload).
 */
export function ExportHeader({
	record,
	attendeeCount,
	pendingCount,
	timeZone
}: {
	record?: MarqueeExportRecord | null
	/** Every previewed row, for the all-resolved subtitle's count. */
	attendeeCount: number
	pendingCount: number
	/** The event's IANA zone: provenance is read in the market's clock. */
	timeZone?: string
}) {
	const { t } = useTranslation()
	const subtitle = (() => {
		if (record) {
			return t('marquee:export_header_subtitle_downloaded', {
				at: formatDate(record.exported_at, 'lll', timeZone),
				rows: record.rows ?? 0
			})
		}
		if (pendingCount === 0) {
			return t('marquee:export_header_subtitle_ready', {
				count: attendeeCount
			})
		}
		return t('marquee:export_header_subtitle')
	})()
	return (
		<div className='flex flex-col gap-1'>
			<h2 className='font-semibold text-lg text-neutral-900'>
				{record
					? t('marquee:export_header_title_downloaded')
					: t('marquee:export_header_title')}
			</h2>
			<p className='text-neutral-500 text-sm'>{subtitle}</p>
		</div>
	)
}
